import { FieldType } from '../../../types/Field.type';
export const ShouldAutoCaptureOrders = {
    priority: 20,
    label: 'fields.payload.business_information.should_auto_capture_orders.label',
    fallbackLabel: 'Would you like to automatically capture orders?',
    tooltip: 'fields.payload.business_information.should_auto_capture_orders.tooltip',
    fallbackTooltip: 'Orders should be captured when handed over in-store or when shipped from a warehouse. By selecting auto-capture, the order will be automatically captured when the consumer confirms the purchase.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    var _a, _b;
    return (((_b = (_a = payload.contract_onboarding_type) === null || _a === void 0 ? void 0 : _a.valueOf) === null || _b === void 0 ? void 0 : _b.call(_a)) === 'UPSELL_WEBSTORE_TO_KPOS');
}
function isApplicable(payload, path) {
    var _a, _b;
    return (((_b = (_a = payload.contract_onboarding_type) === null || _a === void 0 ? void 0 : _a.valueOf) === null || _b === void 0 ? void 0 : _b.call(_a)) === 'UPSELL_WEBSTORE_TO_KPOS');
}
